import { gql, TypedDocumentNode } from "@apollo/client";

import { PublicWorkerPool } from "types/generated";

type GetPublicWorkerPoolData = {
  publicWorkerPool: Pick<PublicWorkerPool, "parallelism" | "busyWorkers" | "pendingRuns">;
};

export const GET_PUBLIC_WORKER_POOL: TypedDocumentNode<GetPublicWorkerPoolData> = gql`
  query GetPublicWorkerPool {
    publicWorkerPool {
      parallelism
      busyWorkers
      pendingRuns
    }
  }
`;
